import React from 'react';
import { Spinner } from './Spinner';
import { concatStyles } from 'utils';
var ABSOLUTE_OVERLAY_STYLES = 'flex h-full w-full absolute top-0 left-0 bg-opacity-75 z-30';
export var AbsoluteOverlay = function (_a) {
    var bgClassName = _a.bgClassName;
    return (React.createElement("div", { className: concatStyles(ABSOLUTE_OVERLAY_STYLES, bgClassName !== null && bgClassName !== void 0 ? bgClassName : 'bg-white') },
        React.createElement(Spinner, { size: "4x", className: "m-auto" })));
};
